import moment from 'moment';

export const dataFormatter = {

    data() {
        return {

        }
    },
    methods: {
        returnMonthName(row) {
            let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            return monthNames[row.billMonth - 1];
        },

        // todo will return a comma separated values with 2 decimals and £
        returnFormattedCurrencyGrid(row, column, cellValue) {
            if (typeof cellValue === 'undefined' || cellValue === null) {
                return '£0'
            } else {
                return this.formatCurrencyTwoPlaces(cellValue.toString().replace(/\B(?=(\d{10})+(?!\d))/g, ","))
            }
        },
        returnCurrency(row, column, cellValue) {
            // console.log('currency', cellValue)
            if (typeof cellValue === 'undefined' || cellValue === null) {
                return '£0.00'
            } else {
                return '£' + parseFloat(cellValue).toFixed(2);
            }
        },
        returnFormattedCurrency(currency) {
            // console.log(currency)
            if (typeof currency === 'undefined' || currency === null) {
                return '£0'
            } else {
                return this.formatCurrencyTwoPlaces(currency.toString().replace(/\B(?=(\d{10})+(?!\d))/g, ","))
            }
        },
        convertDate(dateToConvert) {
            let dateArray = dateToConvert.split("/");
            return new Date(dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2])
        },
        invertDate(dateToConvert) {
            let dateArray = dateToConvert.split("/");
            return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
        },
        returnDaysMinusSeven() {
            const date = new Date();
            date.setDate(date.getDate() - 7)
            return date.toLocaleDateString('en-GB');
        },
        returnMonthsMinusOne() {
            const date = new Date();
            date.setMonth(date.getMonth() - 1)
            return date.toLocaleDateString('en-GB');
        },
        returnMonthsMinusThree() {
            const date = new Date();
            date.setMonth(date.getMonth() - 2)
            return date.toLocaleDateString('en-GB');
        },
        returnYearMinusOne() {
            const date = new Date();
            date.setFullYear(date.getFullYear() - 1)
            return date.toLocaleDateString('en-GB')
        },
        formatCurrencyTwoPlaces(currency) {
            // console.log('currency', currency)
            return '£' + parseFloat(currency).toFixed(2);
        },
        formatPercentage(row, column, cellValue) {
            if (typeof cellValue === 'undefined') {
                return '0%'
            } else {
                return cellValue.toString() + '%';
            }
        },
        returnWithCommas(inputText) {
            // pattern works from right to left
            var commaPattern = /(\d+)(\d{3})(\.\d*)*$/;
            var callback = function (match, p1, p2, p3) {
                return p1.replace(commaPattern, callback) + ',' + p2 + (p3 || '');
            };
            return inputText.replace(commaPattern, callback);
        },
        returnMonthFromDate(dateToConvert) {
            let monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
            let dateArray = dateToConvert.split("-");
            return monthNames[dateArray[1] - 1];
        },
        formatDateDDMMYYYY(date) {
            // console.log(date.ordered)
            if (date !== null && (date.ordered !== null)) {
                let splitDate = date.ordered.split("T")[0]
                let dateArray = splitDate.split("-");
                return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
            } else {
                return ''
            }

        },
        formatDateDDMMYYYYCreated(date) {
            // console.log(date.created)
            if (date !== null && (date.created !== null)) {
                let splitDate = date.created.split("T")[0]
                let dateArray = splitDate.split("-");
                return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
            } else {
                return ''
            }

        },
        formatDateDDMMYYYYCreatedNoneZ(date) {
            // console.log(date.created)
            if (date !== null && (date.created !== null)) {
                let splitDate = date.created.split(" ")[0]
                let dateArray = splitDate.split("-");
                return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
            } else {
                return ''
            }
        },
        formatDateDDMMYYYYDepatch(date) {
            // console.log(date.despatchDue)
            if (date !== null && (date.despatchDue !== null)) {
                let splitDate = date.despatchDue.split("T")[0]


                let dateArray = splitDate.split("-");
                return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
            } else {
                return ''
            }
        },
        formatDateDDMMYYYYDepatched(date) {
            // console.log(date.despatched)
            if (date !== null && (date.despatched !== null)) {
                let splitDate = date.despatched.split("T")[0]
                let dateArray = splitDate.split("-");
                return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
            } else {
                return ''
            }
        },
        formatDateDDMMYYYYPrinted(date) {
            // console.log(date.printed)
            if (date !== null && (date.printed !== null)) {
                let splitDate = date.printed.split("T")[0]
                let dateArray = splitDate.split("-");
                return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
            } else {
                return ''
            }
        },
        formatDateDDMMYYYYFinished(date) {
            // console.log(date.finished)
            if (date !== null && (date.finished !== null)) {
                let splitDate = date.finished.split("T")[0]
                let dateArray = splitDate.split("-");
                return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
            } else {
                return ''
            }
        },
        formatDateTime(date) {
            // console.log(date.ordered)
            if (date !== null && (date.ordered !== null)) {
                // let dateArray = date.ordered.split("T")[0].split("-");


                let splitDate = date.ordered.split("T")
                let dateArray = splitDate[0].split("-");


                // if (splitDate.length > 1) {
                    return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0] + ' ' + splitDate[1].split(".")[0].replace('Z', '');
                // } else {
                //     return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0]
                // }
            } else {
                return ''
            }

        },
        formatLastOrderedDate(date) {
            // console.log(date.ordered)
            if (date !== null && (date.lastOrder !== null)) {
                // let dateArray = date.ordered.split("T")[0].split("-");


                let splitDate = date.lastOrder.split("T")
                let dateArray = splitDate[0].split("-");


                // if (splitDate.length > 1) {
                return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
                // } else {
                //     return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0]
                // }
            } else {
                return ''
            }

        },
        formatProductType(order) {

            let productType = ''

            switch (order.type) {
                case 'PDFUPLOAD':
                    if (order.productCat1 === 'IMA') {
                        productType = 'Directmailr'
                    } else {
                        productType = 'Instant Print'
                    }

                    break;
                case 'TOOLKIT':
                    productType = 'Marketing Toolkit'
                    break;
                case 'EMAIL':
                    productType = 'Email'
                    break;
                case 'BESPOKE':
                    productType = 'Bespoke'
                    break;
                case 'DELIVERY':
                    if (order.productCode === 'IMDM01') {
                        productType = 'Postage'
                    } else {
                        productType = 'Delivery'
                    }

                    break;
                case 'PHOTOFIXR':
                    productType = 'Photofixr'
                    break;
                default:
                    productType = ''
            }

            return productType;

        },
        formatOrderSource(order) {

            let orderSource = ''

            switch (order.source) {
                case 'PDFUPLOAD':
                    orderSource = 'Instant Print'
                    break;
                case 'TOOLKIT':
                    orderSource = 'Marketing Toolkit'
                    break;
                case 'EMAIL':
                    orderSource = 'Email'
                    break;
                case 'BESPOKE':
                    orderSource = 'Bespoke'
                    break;
                case 'DELIVERY':
                    orderSource = 'Delivery'
                    break;
                case 'PHOTOFIXR':
                    orderSource = 'Photofixr'
                    break;
                default:
                    orderSource = ''
            }

            return orderSource;

        },
        formatOrderRef(order) {

            let orderRef = ''

            if (order.source === 'BESPOKE') {
                orderRef = order.jobName
            } else {
                orderRef = order.billDescription.replace(/^IM /, '').replace(/^LH /, '')
            }

            if (order.productCode === 'DBSDATA01') {
                orderRef = 'Data charge (Household)'
            }

            if (order.productCode === 'LHDATA01') {
                orderRef = 'Data charge (OTM)'
            }

            return orderRef;

        }
    }
}